import {StyledNoUpcomingCallBox} from "../calls/upcoming-calls/upcoming-calls.style";

export function EmptyState({message}: {message: string}) {
  return (
    <StyledNoUpcomingCallBox>
      <p className="info-text">{message}</p>
    </StyledNoUpcomingCallBox>
  );
}
